// extracted by mini-css-extract-plugin
export default {"addDeleteButtonContainer":"OpenScheduleTab_addDeleteButtonContainer__zjBOg","startOverButtonContainer":"OpenScheduleTab_startOverButtonContainer__lia6W"};